import { render, staticRenderFns } from "./PadlockIcon.vue?vue&type=template&id=8ed61088&scoped=true&"
import script from "./PadlockIcon.vue?vue&type=script&lang=ts&"
export * from "./PadlockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed61088",
  null
  
)

export default component.exports